<template>
    <component :is="tagName" v-if="visible" class="pointer text-break text-link" :class="classNames" @click="onClick">
        <slot v-if="loaded" name="default" />
        <Placeholder v-else :width="[minWidth, maxWidth]" :height="14" />
    </component>
</template>

<script lang="ts" setup>
import type { Header } from '../helpers';

defineOptions({
    name: 'ListViewHeader',
    inheritAttrs: false
});

export interface Props
{
    index?: number;
    header?: Header;
}

const $attrs = useAttrs() as any;

const props = withDefaults(defineProps<Props>(), {});
const loaded = inject<Ref<boolean>>('loaded');
const layout = inject<Ref<string>>('layout');
const item = inject<ComputedRef<any>>('item');
const rowClick = inject<(item: any, index: number, e: any) => void>('row-click');

const table = computed(() => layout.value == 'table');
const tagName = computed(() => table.value ? 'td' : 'h5');
const classNames = computed(() => table.value ? '' : 'mb-0');
const visible = computed(() => props.header.visible);

const minWidth = computed(() => parseInt($attrs.width as string) || 100);
const maxWidth = computed(() => parseInt($attrs.width as string) || 175);

const onClick = (e: any): void =>
{
    if (rowClick)
    {
        rowClick(item.value, props.index, e);
    }
};
</script>
